
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speeds',
      description: 'Experience blazing-fast connection speeds with our optimized VPN servers. Stream, download, and browse without any lag or buffering issues.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to servers in multiple countries around the world. Access geo-restricted content and enjoy a truly global internet experience.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Logs Policy',
      description: 'We never track, collect, or share your private data. Your online activities remain completely private and anonymous at all times.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Compatible with Windows, Mac, iOS, Android, and more for comprehensive security.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is always ready to help you. Get assistance anytime, anywhere with our round-the-clock customer service.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose MIDMAS VPN
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover the powerful features that make our VPN the perfect choice for protecting your online privacy and security
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
